document.querySelectorAll('.lang-btn').forEach(button => {
  button.addEventListener('click', function () {
      document.querySelectorAll('.lang-btn').forEach(btn => btn.classList.remove('active'));
      this.classList.add('active');
  });
});
